export const covertHeaders = [
  { label: 'By chat bot', key: 'byChatBot' },
  { label: 'By customer support', key: 'byCustomerSupport' },
]
